import {
    ApiDataResponse,
    BaseApiResponse,
} from '@frontend/jetlend-core/src/models/api';
import {
    apiPostRequest,
    apiGetRequest,
} from '../api';
import { buildIntegrityHeaders } from '../integrity';
import {
    BorrowerLimitPrescoringContacts,
    BorrowerLimitPrescoringInitialData,
    BorrowerLimitPrescoringRequest,
    BorrowerLimitPrescoringStatus,
} from '@app/models/borrowers/limitPrescoring';

/**
 * Запрос для получения прескоринга лимита для заемщика по ИНН
 * @param inn ИНН заемщика
 * @returns Флаг наличия заемщика на платформе
 * @see BorrowerLimitPrescoringRequest
 */
export async function apiPostLimitPrescoring(values: BorrowerLimitPrescoringInitialData): Promise<ApiDataResponse<BorrowerLimitPrescoringRequest>> {
    const {
        inn,
        company_data,
    } = values;

    // return testResponse<BorrowerLimitPrescoringRequest>({
    //     has_account: true,
    // });

    return apiPostRequest(`~/lend/api/public/scorings/${inn}`, {
        inn,
        company_data,
    }, {
        headers: await buildIntegrityHeaders('lend_limit'),
    });
}

/**
 * Запрос для получения статуса прескоринга по ИНН
 * @param inn ИНН заемщика
 * @returns Статус прескоринга, в случае успешного прескоринга - информацию о лимите и ссылку на визард, в случае отказа - дату следующего возможного прескоринга
 * @see BorrowerLimitPrescoringStatus
 */
export async function apiGetLimitPrescoringStatus(values: BorrowerLimitPrescoringInitialData): Promise<ApiDataResponse<BorrowerLimitPrescoringStatus>> {
    const { inn } = values;

    // return testResponse<BorrowerLimitPrescoringStatus>({
    //     scoring_status: BorrowerLimitPrescoringStatusType.UPDATING,
    // });

    return apiGetRequest(`~/lend/api/public/scorings/${inn}/status`);
}

/**
 * Запрос для регистрации по ИНН
 * @param inn ИНН заемщика
 * @param data Данные для регистрации
 */
export async function apiPostLimitPrescoringRegister(values: BorrowerLimitPrescoringContacts): Promise<BaseApiResponse> {
    const {
        inn,
        ...data
    } = values;
    return apiPostRequest(`~/lend/api/public/scorings/${inn}/register`, data, {
        headers: await buildIntegrityHeaders('lend_limit_contacts'),
    });
}
